import React from 'react'
import useGaugeStyles from 'pages/HealthCenter/ReportV1/BrainFunctionalConnectivity/Elements/components/style'
import {HEALTH_POINT} from 'constants/HealthConstant'

interface Props {
  index: number
  percentile?: {
    low: number
    high: number
  }
}
function ProgressBar({
  index,
  percentile = {
    low: HEALTH_POINT.low,
    high: HEALTH_POINT.high,
  },
}: Props) {
  const classes = useGaugeStyles()

  return (
    <>
      {index === 3 ? (
        <div className={classes.botBar}>
          <div>
            <div
              className={classes.marker3}
              style={{left: `${percentile.low}%`}}
            >
              <span />
            </div>
            <div className={classes.marker3} style={{left: '50%'}}>
              <div />
            </div>
            <div
              className={classes.marker3}
              style={{left: `${percentile.high}%`}}
            >
              <span />
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.processBar}>
          <span
            className={classes.marker1}
            style={{top: `${percentile.low}%`}}
          />
          <span
            className={classes.marker1}
            style={{top: `${percentile.high}%`}}
          />
        </div>
      )}
    </>
  )
}
export default ProgressBar
